import apiService from "./ApiService";

export class SalonService {
  async findAll() {
    return (await apiService.get("/api/services", {})).data;
  }

  async findAllWithPackage() {
    return (await apiService.get("/api/services/findAllWithPackage", {})).data;
  }

  async save(data) {
    await apiService.post("/api/services", data);
  }

  async findOne(id: string) {
    return (await apiService.get(`/api/services/${id}`)).data;
  }

  async findWithServiceType(serviceType: string) {
    return await apiService.get(`/api/findAllWithServiceType`), serviceType;
  }
  async update(id: string, body) {
    await apiService.put(`/api/services/${id}`, body);
  }
  async delete(id: string): Promise<void> {
    await apiService.delete(`/api/services/${id}`);
  }
  async serviceType() {
    return (await apiService.get(`/api/service-type`)).data;
  }
  async saveServiceType(serviceName) {
    return await apiService.post(`/api/service-type`, { serviceName });
  }

  async packages() {
    return (await apiService.get(`/api/packages`)).data;
  }

  async dealsCreate(data) {
    return await apiService.post("/api/packages", data);
  }
}
const salonService = new SalonService();
export { salonService as default };
